module.exports = __webpack_public_path__ + "img/spinner-clear.68b131d9.svg";